import { type ReactNode } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export { default as nimbraEdgeLogo } from '../img/logo-edge.svg'
export { default as nimbraEdgeOsLogo } from '../img/logo-edgeos.svg'
export { default as nimbraConsoleLogo } from '../img/logo-console.svg'

const LoginImg = styled('img')({
    height: '44px',
    margin: '0 auto',
    display: 'block',
})

export interface LoginDialogLayoutProps {
    children: ReactNode
    title: string
    /** Custom logo element rendered above the title (overrides logoSrc). */
    logo?: ReactNode
    /** Logo image URL rendered at consistent size (ignored if logo is provided). */
    logoSrc?: string
}

/** Shared visual frame for sign-in and the steps required before entering an application. */
export const LoginDialogLayout = ({ children, logo, logoSrc, title }: LoginDialogLayoutProps) => (
    <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {logo ??
                (logoSrc && (
                    <Box sx={{ width: '100%', my: 2 }}>
                        <LoginImg src={logoSrc} alt="Logo" />
                    </Box>
                ))}
            <Typography component="h1" variant="h5">
                {title}
            </Typography>
            {children}
        </Box>
    </Container>
)
